import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import moment from 'moment/moment';

import { DD_SLASH_MMM_SLASH_YYYY } from '../../../../../../../constants/dateFormat';
import { muiDatePickersLocaleText } from '../../../../../../../services/i18n/mui';

export const PMWorkbookTableDatePicker = ({ id, value, field, hasFocus }) => {
  const apiRef = useGridApiContext();
  const ref = React.useRef(null);

  const handleChange = newValue => {
    apiRef.current.setEditCellValue({ id, field, value: newValue });
  };

  useEffect(() => {
    if (hasFocus && ref.current) {
      const input = ref.current.querySelector(`input`);
      input?.focus();
    }
  }, [hasFocus]);
  return (
    <Box ref={ref} sx={{ width: '100%' }}>
      <DesktopDatePicker
        value={moment(value)}
        onChange={handleChange}
        format={DD_SLASH_MMM_SLASH_YYYY}
        slotProps={{
          textField: { variant: 'standard', 'data-testid': `${field}-date-picker` }
        }}
        sx={{
          padding: '0px 10px',
          '.MuiInputBase-input': {
            fontSize: '13px'
          },
          '.MuiSvgIcon-root': {
            width: '20px',
            height: '20px'
          }
        }}
        localeText={muiDatePickersLocaleText({
          fieldMonthPlaceholder: params => (params.contentType === 'letter' ? 'MMM' : params.format)
        })}
      />
    </Box>
  );
};
